export default __webpack_public_path__ + "graphics/photographs.0e7bf75b.jpg";